export default function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n  <div class="label-editor-container">\n    <div class="label-editor-header">\n      <input class="form-field text-field js-label-search" placeholder="Filter labels">\n      <button class="nav-button js-CategoryEditor-close"\n              tabindex="0">\n        <svg class="nav-text icon nav-icon" viewBox="0 0 30 30" role="presentation">\n            <title>Save &amp; close</title>\n            <use xlink:href="#svg-sliders">Save &amp; close</use>\n        </svg>\n      </button>\n    </div>\n    <div class="label-editor-list" tabindex="-1">\n      ';
 _.each(data.labels, function(label) { ;
__p += '\n        <input class="label-editor-list-item-checkbox"\n                type="checkbox" name="' +
((__t = ( label.name )) == null ? '' : __t) +
'"\n                id="label-' +
((__t = ( label.remoteName )) == null ? '' : __t) +
'"\n                data-color="' +
((__t = (label.color)) == null ? '' : __t) +
'"\n                data-remotename="' +
((__t = ( label.remoteName )) == null ? '' : __t) +
'"\n                tabindex="-1">\n        <label class="label-editor-list-item label-' +
((__t = ( label.remoteName )) == null ? '' : __t) +
'" for="label-' +
((__t = ( label.remoteName )) == null ? '' : __t) +
'" tabindex="0">\n          <span class="small">' +
((__t = ( label.name )) == null ? '' : __t) +
'</span>\n        </label>\n      ';
 }); ;
__p += '\n    </div>\n  </div>\n\n';
return __p
}